import CodeBlock from "./code-block";
import HeadingBlock from "./heading-block";

export { CodeBlock, HeadingBlock };
export default { CodeBlock, HeadingBlock };
